import styled, { css } from "styled-components";

export const MaterialIcons = styled.span<{ color?: string, backgroundColor?: string }>`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;

    color: ${props => props.color || "#424242"};

    ${props => props.backgroundColor && css`
        background: ${props.backgroundColor};
    `}
`;